import {
  GET_ADDON_UOM,
  GET_CART,
} from "../../database/get-stored-data";
import {
  SET_STORE_ADDONUOM,
  SET_STORE_CART,
  SET_STORE_PAGE_URL,
} from "../../database/store-data";
import { GET_CART_COUNT } from "../../functions/funtion";
import { F_Fammily } from "../../util/config-fonts";
import { PT_CART } from "../../routes/stack/paths/pt-cart";
import { PT_SIGNIN } from "../../routes/stack/paths/pt-profile";
import { Colors } from "../../util/colors";
import { dto_Customer } from "../../classes/dto-customer";
import { CSP } from "../../config/config";
import CartItemList from "../render-cart-item/render-drawer-cart";
import PlaceHolder from "../../pages/home/components/product-list-place-holder/product-list-place-holder";
import Alert from "../Alert";
import React from "react";
var $ = require("jquery");

export default class SummaryCart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CartData: [],
      Isloading: false,
    };
  }

  async componentDidMount() {
    // let Localcart = await GET_CART();
    // if (Localcart === undefined) {
    //   Localcart = [];
    // } CartData: Localcart,
    this.setState({ Isloading: true });
  }

  render() {
    return (
      <>
        {this.state.Isloading ? (
          <div style={{ position: "relative", height: "100%" }}>
            {this.props.CartData.length === 0 ? (
              <p>No data found</p>
            ) : (
              <>
                <div
                  style={{
                    overflow: "auto",
                    maxHeight: "calc(100% - 60px)",
                  }}
                >
                  {this.props.CartData.map((rs, i) => {
                    return (
                      <CartItemList
                        key={rs.PID + "SummaryCart" + i}
                        item={rs}
                        index={i}
                        NavigateToProductPage={async (item) => {
                          if (CSP === "AV" && item.PID === 1224929) {
                            return;
                          } else {
                            await this.props.ItemClick(item);
                          }
                        }}
                        RemoveItemFromCart={async (
                          i,
                          LineID,
                          AddonLineId,
                          item,
                        ) => {
                          if (CSP === "AV" && item.PID === 1224929) {
                            return;
                          } else {
                            await this.Delete(i, LineID, AddonLineId);
                          }
                        }}
                      />
                    );
                  })}
                </div>
                <button
                  style={{
                    position: "absolute",
                    bottom: 10,
                    cursor: "pointer",
                    width: "100%",
                    height: "48px",
                    background: Colors.DarkGreyScale,
                    fontFamily: F_Fammily.Medium,
                    color: Colors.FontColor,
                    borderRadius: "8px",
                    marginTop: 6,
                    border: "none",
                    fontSize: "16px",
                  }}
                  onClick={async () => {
                    if (
                      dto_Customer.CSID === 0 ||
                      dto_Customer.CSID === undefined
                    ) {
                      await SET_STORE_PAGE_URL(PT_CART);
                      this.props.navigate(PT_SIGNIN);
                      return;
                    }

                    this.props.navigate(PT_CART);
                  }}
                >
                  PROCEED TO CHECK OUT
                </button>
              </>
            )}
          </div>
        ) : (
          <PlaceHolder />
        )}
      </>
    );
  }

  async Delete(i, LineID, AddonLineId) {
    let dataCart = [...this.props.CartData];
    let PID = dataCart[i].LineID;
    let ProductName = dataCart[i].Desc;
    if (LineID === PID) {
      let LocalCart = await GET_CART();
      if (LocalCart !== undefined && LocalCart.length > 0) {
        Alert.ConfirmationMessageBox({
          ConfirmButtonFunction: async () => {
            let ADDonUOMList = await GET_ADDON_UOM();
            dataCart.splice(i, 1);

            if (ADDonUOMList !== undefined) {
              if (ADDonUOMList.length > 0 && ADDonUOMList !== undefined) {
                for (var k = 0; k < ADDonUOMList.length; k++) {
                  if (AddonLineId === ADDonUOMList[k].LINEID) {
                    ADDonUOMList.splice(k, 1);
                  }
                }
              }
            }
            if (dataCart.length > 0) {
              for (var j = 0; j < dataCart.length; j++) {
                dataCart[j].LineID = j + 1;
              }
            }
            await SET_STORE_CART(dataCart);
            await SET_STORE_ADDONUOM(ADDonUOMList);
            this.setState({ CartData: dataCart });
            if (typeof this.props.onCartUpdated === "function") {
              this.props.onCartUpdated([...dataCart]);
            }
            window.dispatchEvent(new CustomEvent("cartUpdated"));
            if (
              dataCart.length === 0 &&
              typeof this.props.closeFunction === "function"
            ) {
              this.props.closeFunction();
            }
            await GET_CART_COUNT();
            let lbl = document.getElementById("viewBasketCount");
            if (lbl) {
              let cart = await GET_CART();
              if (cart === undefined) {
                $("#viewBasketCount").html(0);
              } else {
                $("#viewBasketCount").html(cart.length);
              }
            }
          },
          ConfirmButtonText: "Yes",
          DismissButtonFunction: () => {},
          Icon: "info",
          Text:
            "Do you want to remove <b>" +
            ProductName +
            "</b> from your cart?" +
            "</div>",
          Tittle: "",
        });
      }
    }
  }
}
